var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2141 22.5938V15.0924H14.1349V22.5938H12.7286V13.6862H17.4714V5.66616H15.8905V2.52408H14.1016V0H12.6953V2.52408H10.9064V5.66616H9.3255V22.5938H7.91925V8.80828H1.78589V22.5938H0V24H24V22.5938H22.2141ZM14.2664 7.40203H15.6726V8.80828H14.2664V7.40203ZM14.2664 10.5441H15.6726V11.9504H14.2664V10.5441ZM5.52464 22.0423H4.11839V20.636H5.52464V22.0423ZM5.52464 18.6783H4.11839V17.272H5.52464V18.6783ZM5.52464 15.3143H4.11839V13.9081H5.52464V15.3143ZM5.52464 11.9504H4.11839V10.5441H5.52464V11.9504ZM12.5305 11.9504H11.1243V10.5441H12.5305V11.9504ZM12.5305 8.80828H11.1243V7.40203H12.5305V8.80828ZM12.6953 4.25991H14.1015V5.66616H12.6953V4.25991ZM17.2967 22.5938H15.8905V16.95H17.2967V22.5938ZM20.4585 22.5938H19.0523V16.95H20.4585V22.5938Z",
    fill: "#050033",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.db46109cc86377a12ade35e5830d024b.svg";
export { ForwardRef as ReactComponent };